import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import GenericMasterList from "../screens/masters/genericmaster/GenericMasterList";
import queryString from "query-string";

const Home = props => {
  const values = queryString.parse(props.location.search);
  const breadCrumbData = [
    { link: "/masters-list", name: "Masters" },
    { link: "/master-profile", name: "Generic Master" },
    {
      link: `/genericmaster-list?id=${values.id}&name=${values.name}`,
      name: values.name
    }
    // { link: "/genericmaster-list", name: props.router.query.name }
  ];
  return (
    <>
      <LayoutContainer>
        <BreadCrumb data={breadCrumbData} />
        <GenericMasterList />
      </LayoutContainer>
    </>
  );
};

export default Home;
